import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { Subject, BehaviorSubject, merge } from 'rxjs';
import { DataSource } from '@angular/cdk/table';
import { takeUntil, tap } from 'rxjs/operators';
import { MatPaginator, MatSort, MatDialog, MatSnackBar } from '@angular/material';
var NotificationListComponent = /** @class */ (function () {
    function NotificationListComponent(_notificationService, _matDialog, _matSnackBar, _translate, _translationLoader) {
        this._notificationService = _notificationService;
        this._matDialog = _matDialog;
        this._matSnackBar = _matSnackBar;
        this._translate = _translate;
        this._translationLoader = _translationLoader;
        this.displayedColumns = ['notification', 'created_at', 'read_at'];
        this.totalPages = 2;
        this.totalElements = 0;
        this.sortField = 'created_at';
        this.sordOrder = 'desc';
        this.pageSize = 10;
        this.lang = 'sr';
        this.categories = [3, 6, 8, 16, 17, 18];
        this._unsubscribeAll = new Subject();
        this._notificationService.currentData = [];
    }
    NotificationListComponent.prototype.getTranslations = function () {
        var _this = this;
        this._translationLoader.getLastLang()
            .then(function (response) {
            _this.lang = response['code'];
            _this._translationLoader.getMultipleTranslationCategories(_this.lang, _this.categories);
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function () {
        }, function (err) {
        });
    };
    NotificationListComponent.prototype.compareNotifs = function (arr1, arr2) {
        var count = 0;
        arr1.forEach(function (el1) {
            arr2.forEach(function (el2) {
                if (el1.id === el2.id && el1.read_at === el2.read_at) {
                    count++;
                }
            });
        });
        return count === arr1.length && this._notificationService.currentData.length !== 0;
    };
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    NotificationListComponent.prototype.loadNotificationsPage = function (comment) {
        console.log('CALL: ' + comment);
        this.dataSource.loadNotifications(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active || 'created_at', this.sort.direction || 'desc', '');
    };
    NotificationListComponent.prototype.markAsRead = function (notification) {
        if (!notification.read_at) {
            this._notificationService.markAsRead(notification.id);
            // this.getTranslations();
            // this.loadNotificationsPage('markAsRead');
        }
    };
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    NotificationListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.dataSource = new FilesDataSource(this._notificationService);
        this.dataSource.loadNotifications(1, this.pageSize, this.sortField, this.sordOrder, '');
        this._notificationService.allNotificationsChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            // refresh table only if there is a difference
            if (!_this.compareNotifs(_this._notificationService.currentData, response.data)) {
                _this.totalPages = Math.floor(response.total / _this.paginator.pageSize) + 1;
                _this.totalElements = response.total;
                _this.dataSource.setData(response.data);
                _this._notificationService.currentData = response.data;
            }
        });
        this._notificationService.newNotifications
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            _this.loadNotificationsPage('newNotifications');
        });
        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (value) {
            _this.getTranslations();
        });
        // this.getTranslations();
    };
    NotificationListComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // reset the paginator after sorting
        this.sort.sortChange.subscribe(function () { return _this.paginator.pageIndex = 0; });
        // on sort or paginate events, load a new page
        merge(this.sort.sortChange, this.paginator.page)
            .pipe(tap(function () { return _this.loadNotificationsPage('ngAfterInit'); }))
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe();
    };
    NotificationListComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    };
    return NotificationListComponent;
}());
export { NotificationListComponent };
// Custom Angular CDK Data Source
var FilesDataSource = /** @class */ (function (_super) {
    tslib_1.__extends(FilesDataSource, _super);
    /**
     * Constructor
     *
     * @param {NotificationsService} _notificationService
     */
    function FilesDataSource(_notificationService) {
        var _this = _super.call(this) || this;
        _this._notificationService = _notificationService;
        _this.notificationsSubject = new BehaviorSubject([]);
        _this.loadingSubject = new BehaviorSubject(false);
        _this.loading$ = _this.loadingSubject.asObservable();
        return _this;
    }
    FilesDataSource.prototype.connect = function () {
        return this.notificationsSubject.asObservable();
    };
    FilesDataSource.prototype.disconnect = function () {
        this.notificationsSubject.complete();
        this.loadingSubject.complete();
    };
    FilesDataSource.prototype.setData = function (data) {
        this.notificationsSubject.next(data);
        this.loadingSubject.next(false);
    };
    FilesDataSource.prototype.compareNotifs = function (arr1, arr2) {
        var count = 0;
        arr1.forEach(function (el1) {
            arr2.forEach(function (el2) {
                if (el1.id === el2.id && el1.read_at === el2.read_at) {
                    count++;
                }
            });
        });
        return count === arr1.length && this._notificationService.currentData.length !== 0;
    };
    FilesDataSource.prototype.loadNotifications = function (page, limit, orderBy, order, search) {
        var _this = this;
        if (page === void 0) { page = 1; }
        if (limit === void 0) { limit = 20; }
        if (orderBy === void 0) { orderBy = 'created_at'; }
        if (order === void 0) { order = 'desc'; }
        if (search === void 0) { search = ''; }
        this.loadingSubject.next(true);
        this._notificationService.listAllNotifications(page, limit, orderBy, order, search).then(function (response) {
            var notifications = response.data;
            notifications.forEach(function (notification) {
                var message = '';
                var message2 = '';
                var message3 = '';
                var message4 = '';
                if ((notification.data.message.match(/%/g) || []).length < 2) {
                    message = notification.data.message;
                }
                else {
                    if ((notification.data.message.match(/%/g) || []).length >= 4) {
                        message = notification.data.message.split('%').slice(0, 1)[0];
                        message2 = notification.data.message.split('%').slice(1, 2)[0];
                        message3 = notification.data.message.split('%').slice(2, 3)[0];
                        message4 = notification.data.message.split('%').slice(3, 4)[0];
                    }
                    else {
                        message = notification.data.message.split('%').slice(0, 1)[0];
                        message2 = notification.data.message.split('%').slice(1, 2)[0];
                    }
                }
                notification.data.message = message;
                notification.data.message2 = message2;
                notification.data.message3 = message3;
                notification.data.message4 = message4;
                // use setTranslation() with the third argument set to true
                // to append translations instead of replacing them
            });
            // refresh table only if there is a difference
            if (!_this.compareNotifs(_this._notificationService.currentData, notifications)) {
                _this.notificationsSubject.next(notifications);
                _this.loadingSubject.next(false);
                _this._notificationService.currentData = notifications;
            }
        });
    };
    return FilesDataSource;
}(DataSource));
export { FilesDataSource };
